<template>
  <b-dropdown class="d-flex" variant="link" toggle-class="text-decoration-none" no-caret :disabled="disabled">
    <template slot="button-content">
      <div class="dot m-auto" :class="'dot-' + (1*value || 0)"></div>
    </template>
    <b-dropdown-item v-for="i in [0, 1, 2, 3, 4]" :key="i" @click="selectValue(i)">
      <div class="dot dot-0 m-auto" :class="'dot-' + i"></div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: 'RatingSelect',
  props: ['value', 'disabled'],
  methods: {
    selectValue (i) {
      this.$emit('input', i)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  .dot {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }

  .dot-0 {
    background-color: $secondary-light;
  }

  .dot-1 {
    background-color: #C8392B;
  }

  .dot-2 {
    background-color: #FADD4B;
  }

  .dot-3 {
    background-color: #AEED62;
  }

  .dot-4 {
    background-color: #3B7433;
  }
</style>
